const ThirdPartyTypes = {
    Axios: Symbol.for('AxiosInstance')
};

export default ThirdPartyTypes;